<script>
	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();

	let video;
	let currentTime = 0;
	let duration;

	let classVolumeOn = "chatwith-volume-show";
	let classVolumeOff = "chatwith-volume-hide";
	let muted = false;
	let videoStyles;
	let paused;

	export let data;
	export let width;
	export let height;
	export let isReturnUser;
	
	$: {
		videoStyles = "border-radius: " + data.rounding +"px;";
		if(data.expandFullScreenMobile){
			videoStyles += "width: " + width + "px;height: " + height + "px;";
		}else {
			videoStyles += "width:225px;height:400px;"
		}      
	}	

	let timer = setInterval(() => {
		if(duration) video.play();
	}, 300);

	const switchVolume = () =>{
		muted = !muted;
		[classVolumeOn, classVolumeOff] = [classVolumeOff, classVolumeOn];
	};

	const repeat = () => {
		currentTime = 0;
		video.play();
	}

	const close = (toChat) => {
		clearInterval(timer);
		dispatch("close", toChat);
	}

	const  format = seconds => {
		if (isNaN(seconds)) return '...';

		const minutes = Math.floor(seconds / 60);
		seconds = Math.floor(seconds % 60);
		if (seconds < 10) seconds = '0' + seconds;

		return `${minutes}:${seconds}`;
	}
	function handleMove(e) {
		if (!duration) return; // video not loaded yet
		if (e.type !== 'touchmove' && !(e.buttons & 1)) return; // mouse not down

		const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
		const { left, right } = this.getBoundingClientRect();
		currentTime = duration * (clientX - left) / (right - left);
	}

</script>

<div class="chatwith-video"  >
	{#if paused}
	<div class="start-screen-container z-index-10000">
		<div class="pause-screen enter-transition">
			<svg on:click="{() => repeat()}" class="start-icon" width="94px" height="94px" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:cc="http://creativecommons.org/ns#" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:svg="http://www.w3.org/2000/svg" xmlns:ns1="http://sozi.baierouge.fr" id="svg2" sodipodi:docname="playbtn_ef.svg" viewBox="0 0 322.22 322.22" version="1.1" inkscape:version="0.48.2 r9819">
				<defs id="defs4">
				  <linearGradient id="linearGradient3765" y2="361.14" gradientUnits="userSpaceOnUse" x2="475.34" gradientTransform="translate(60.041 8.3639)" y1="58.089" x1="473.32" inkscape:collect="always">
					<stop id="stop3897" style="stop-color:#00a0f0" offset="0"/>
					<stop id="stop3899" style="stop-color:#0028d0" offset="1"/>
				  </linearGradient>
				  <filter id="filter3869" height="1.5" width="1.5" color-interpolation-filters="sRGB" y="-.25" x="-.25" inkscape:label="Drop shadow">
					<feGaussianBlur id="feGaussianBlur3871" result="blur" stdDeviation="8" in="SourceAlpha"/>
					<feColorMatrix id="feColorMatrix3873" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.8 0 " type="matrix" result="bluralpha"/>
					<feOffset id="feOffset3875" result="offsetBlur" dy="0" dx="0" in="bluralpha"/>
					<feMerge id="feMerge3877">
					  <feMergeNode id="feMergeNode3879" in="offsetBlur"/>
					  <feMergeNode id="feMergeNode3881" in="SourceGraphic"/>
					</feMerge>
				  </filter>
				  <linearGradient id="linearGradient4015" y2="345.01" gradientUnits="userSpaceOnUse" x2="461.06" gradientTransform="matrix(1.1393 0 0 1.1393 10.099 -23.566)" y1="79.014" x1="459.29" inkscape:collect="always">
					<stop id="stop3891" style="stop-color:#00a0f0" offset="0"/>
					<stop id="stop3893" style="stop-color:#0028d0" offset="1"/>
				  </linearGradient>
				  <linearGradient id="linearGradient4017" y2="187.67" gradientUnits="userSpaceOnUse" x2="447.5" gradientTransform="translate(0,4)" y1="72.442" x1="381.42" inkscape:collect="always">
					<stop id="stop3025" style="stop-color:#ffffff" offset="0"/>
					<stop id="stop3027" style="stop-color:#dfdfdf;stop-opacity:0" offset="1"/>
				  </linearGradient>
				</defs>
				
				<g id="layer1" inkscape:label="Layer 1" inkscape:groupmode="layer" transform="translate(-254.09 -51)">
				  <path id="path2985" style="fill:url(#linearGradient4015)" d="m415.19 51c-88.984 0-161.09 72.141-161.09 161.12 0 66.985 40.861 124.38 99.031 148.69-42.591-25.88-71.031-72.711-71.031-126.19 0-81.489 66.043-147.56 147.53-147.56 75.824 0 138.28 57.211 146.59 130.81 0.0671-1.911 0.0937-3.8226 0.0937-5.75 0-88.98-72.14-161.12-161.12-161.12zm13.125 42.625c-77.876 0-141 63.124-141 141 0 67.423 47.323 123.77 110.56 137.69 5.6908 0.60831 11.46 0.90625 17.312 0.90625 66.266 0 123.19-40.011 147.94-97.188 4.0154-13.092 6.1875-26.998 6.1875-41.406 0-77.876-63.124-141-141-141z" inkscape:export-ydpi="35" inkscape:export-filename="C:\Users\John\Desktop\play.png" inkscape:connector-curvature="0" inkscape:export-xdpi="35"/>
				  <path id="path2985-1" sodipodi:rx="141.42136" sodipodi:ry="141.42136" style="fill:#ffffff" sodipodi:type="arc" d="m497 206.86c0 78.105-63.316 141.42-141.42 141.42-78.105 0-141.42-63.316-141.42-141.42 0-78.105 63.316-141.42 141.42-141.42 78.105 0 141.42 63.316 141.42 141.42z" inkscape:export-ydpi="35" inkscape:export-filename="C:\Users\John\Desktop\play.png" transform="matrix(.83929 0 0 .83929 116.77 38.493)" sodipodi:cy="206.8645" sodipodi:cx="355.5737" inkscape:export-xdpi="35"/>
				  <path id="rect2997" style="fill:#deeaff" d="m414.68 92.819-35.588 35.588h-46.881v46.881l-35.588 35.588 35.588 35.588v48.872h48.903l33.566 33.566 33.566-33.566h50.894v-50.894l33.566-33.566-33.566-33.566v-48.903h-48.872l-35.588-35.588z" inkscape:export-ydpi="35" inkscape:export-filename="C:\Users\John\Desktop\play.png" inkscape:connector-curvature="0" inkscape:export-xdpi="35"/>
				  <path id="path2989" style="filter:url(#filter3869);fill:url(#linearGradient3765)" d="m396.7 111.91c16.057 0 27.275 12.319 27.275 12.319s40.659 41.248 60.988 61.872c0 0 13.995 14.105 13.995 26.516s-13.995 26.516-13.995 26.516l-60.988 61.872s-10.414 12.319-27.275 12.319c-16.862 0-25-12.319-25-12.319s-6.4286-33.807-6.4286-92.674c0-58.868 6.4286-80.531 6.4286-80.531s8.9431-15.89 25-15.89z" inkscape:export-ydpi="35" sodipodi:nodetypes="zccscczczcz" inkscape:export-filename="C:\Users\John\Desktop\play.png" inkscape:connector-curvature="0" inkscape:export-xdpi="35"/>
				  <path id="path3018" style="fill:url(#linearGradient4017)" d="m413.16 66.406c-78.105 0-141.44 63.333-141.44 141.44 0 10.229 1.0934 20.2 3.1562 29.812 41.237-55.491 107.27-91.438 181.72-91.438 32.58 0 63.544 6.8859 91.531 19.281-18-57.42-71.62-99.094-134.97-99.094z" inkscape:export-ydpi="35" inkscape:export-filename="C:\Users\John\Desktop\play.png" inkscape:connector-curvature="0" inkscape:export-xdpi="35"/>
				</g>
				
			  </svg>
		</div>
	</div>
	{/if}
	<div class="chatwith-video-controls" style="opacity: {duration ? 1 : 0}">
		<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
			width="32" height="32"
			on:click="{() => repeat()}"
			viewBox="0 0 24 24"
			transform="scale(-1 -1)"
			style=" fill:#ffffff;">
			<path d="M 2 2 L 4.9394531 4.9394531 C 3.1262684 6.7482143 2 9.2427079 2 12 C 2 17.514 6.486 22 12 22 C 17.514 22 22 17.514 22 12 C 22 6.486 17.514 2 12 2 L 12 4 C 16.411 4 20 7.589 20 12 C 20 16.411 16.411 20 12 20 C 7.589 20 4 16.411 4 12 C 4 9.7940092 4.9004767 7.7972757 6.3496094 6.3496094 L 9 9 L 9 2 L 2 2 z"></path>
		</svg>
		<div class="chatwith-video-info">
			<progress value="{(currentTime / duration) || 0}"/>
			<span class="time">{format(currentTime)} / {format(duration)}</span>
		</div>
		<svg xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
			width="32" height="32"
			on:click="{() => switchVolume()}"
			viewBox="0 0 518.518 518.518"
			style="enable-background:new 0 0 518.518 518.518;fill:#ffffff;">
			<path d="M253.674,80.899L90.27,197.638H26.392C11.857,197.638,0,209.495,0,224.03v70.457c0,14.534,11.857,26.392,26.392,26.392
				H90.27l163.557,116.739c11.857,8.491,21.419,3.52,21.419-11.016V91.915C275.246,77.38,265.607,72.407,253.674,80.899z"/>
			<path  class={classVolumeOn}  d="M342.338,81.97c-12.164,0-22.033,9.869-22.033,22.032s9.869,22.032,22.033,22.032c72.98,0,132.115,59.135,132.115,132.116
				c0,72.981-59.135,132.115-132.115,132.115c-12.164,0-22.033,9.869-22.033,22.032s9.869,22.032,22.033,22.032
				c97.307,0,176.18-78.872,176.18-176.18C518.518,160.918,439.723,81.97,342.338,81.97z"/>
			<path  class={classVolumeOn}  d="M342.338,313.153c-12.164,0-22.033,9.868-22.033,22.031c0,12.164,9.869,22.032,22.033,22.032
				c54.773,0,99.066-44.37,99.066-99.067c0-54.698-44.369-99.067-99.066-99.067c-12.164,0-22.033,9.868-22.033,22.032
				s9.869,22.032,22.033,22.032c30.369,0,55.08,24.633,55.08,55.08C397.418,288.673,372.785,313.153,342.338,313.153z"/>

			<path class={classVolumeOff} d="M452.115,260.329l62.5-62.501c5.201-5.202,5.201-13.846,0-19.048l-12.623-12.623c-5.201-5.202-13.846-5.202-19.049,0
			l-62.5,62.5l-62.041-62.042c-5.201-5.202-13.846-5.202-19.049,0l-12.623,12.623c-5.201,5.202-5.201,13.847,0,19.048l62.043,62.042
			L326.73,322.37c-5.201,5.202-5.201,13.847,0,19.049l12.623,12.622c5.203,5.202,13.848,5.202,19.049,0L420.443,292l62.041,62.041
			c5.203,5.202,13.848,5.202,19.049,0l12.623-12.622c5.201-5.202,5.201-13.847,0-19.049L452.115,260.329z"/>
		</svg>
	</div>
	<video
		src={isReturnUser && data.returningVideoSplashUrl?data.returningVideoSplashUrl:data.videoSplashUrl}
		bind:currentTime
		bind:duration
		bind:muted
		bind:paused
		bind:this={video}
		on:mousemove={handleMove}
		style={videoStyles}
		playsinline
		autoplay
	>
		<track kind="captions"/>
	</video>


	<div class="chatwith-video-close" style="opacity: {duration ? 1 : 0}">
		<svg xmlns="http://www.w3.org/2000/svg" 
			on:click="{() => close()}"
			viewBox="0 0 24 24" width="32px" height="32px" style="fill:black">
			<circle cx="12" cy="12" r="10" style="fill:white"/>
			<path d="M14.812,16.215L7.785,9.188c-0.384-0.384-0.384-1.008,0-1.392l0.011-0.011c0.384-0.384,1.008-0.384,1.392,0l7.027,7.027 c0.384,0.384,0.384,1.008,0,1.392l-0.011,0.011C15.82,16.599,15.196,16.599,14.812,16.215z"/><path d="M7.785,14.812l7.027-7.027c0.384-0.384,1.008-0.384,1.392,0l0.011,0.011c0.384,0.384,0.384,1.008,0,1.392l-7.027,7.027 c-0.384,0.384-1.008,0.384-1.392,0l-0.011-0.011C7.401,15.82,7.401,15.196,7.785,14.812z"/>
		</svg>
	</div>

	<div class="chatwith-video-close" style="opacity: {duration ? 1 : 0}">
		<svg xmlns="http://www.w3.org/2000/svg" 
			on:click="{() => close(false)}"
			viewBox="0 0 24 24" width="32px" height="32px" style="fill:black">
			<circle cx="12" cy="12" r="10" style="fill:white"/>
			<path d="M14.812,16.215L7.785,9.188c-0.384-0.384-0.384-1.008,0-1.392l0.011-0.011c0.384-0.384,1.008-0.384,1.392,0l7.027,7.027 c0.384,0.384,0.384,1.008,0,1.392l-0.011,0.011C15.82,16.599,15.196,16.599,14.812,16.215z"/><path d="M7.785,14.812l7.027-7.027c0.384-0.384,1.008-0.384,1.392,0l0.011,0.011c0.384,0.384,0.384,1.008,0,1.392l-7.027,7.027 c-0.384,0.384-1.008,0.384-1.392,0l-0.011-0.011C7.401,15.82,7.401,15.196,7.785,14.812z"/>
		</svg>		
	</div>
	{#if data.videoAgent}
	<div class="chatwith-video-closebutton" style="opacity: {duration ? 1 : 0};{data.expandFullScreenMobile?"top: "+ height* 0.8 + "px;":"top: 320px;"}">
		<button
			on:click={() => close(true)}
			style="background:{data.color};color:#fff">
			{#if (data.videoAgentButtonText)}
			{data.videoAgentButtonText}
			{:else}
			Let's chat!
			{/if}
  		</button>
	</div>
	{/if}
</div>

<style>
	.chatwith-video{
		position:relative;
		justify-content: center;
    	display: flex;
	}

	.chatwith-video video {
		top: 0;
		bottom:0;
		left:0;
		right:0;
		position:absolute;
		object-fit: cover;
	}
	.chatwith-video-controls {
		width: 100%;
		transition: opacity 1s;
		display: flex;
		margin: 30px 20px;
		z-index: 999;
	}

	.chatwith-video-controls svg:first-child,
	.chatwith-video-controls svg:last-child{
		padding-left: 10px;
		cursor:pointer;
	}

	.chatwith-video-info {
		width: 100%;
		text-align: right;
	}

	.chatwith-video-info span {
		padding: 0.2em 0.5em;
		color: white;
		font-size: 0.8em;
		user-select: none;
	}
	.chatwith-video-info progress {
		width: 100%;
    	height: 8px;
	}

	.chatwith-video-info progress::-webkit-progress-bar {
		background-color: rgba(0,0,0,0.2);
	}

	.chatwith-video-info progress::-webkit-progress-value {
		background-color: rgba(255,255,255,0.6);
	}
	.chatwith-volume-show{
		display:block;
	}
	.chatwith-volume-hide{
		display:none;
	}
	.chatwith-video-close{
		top: -12px;
		z-index: 999;
		position: absolute;
		cursor:pointer;
		transition: opacity 1s;
	}
	.chatwith-video-closebutton{
		top: 320px;
		z-index: 999;
		position: absolute;
		transition: opacity 1s;
	}
	.chatwith-video-closebutton button{
		width: 100%;
		text-align: center;
		padding: 13px;
		box-sizing: border-box;
		border-radius: 5px;
		margin-bottom: 10px;
		border: none;
		font-size: 16px;
    		cursor: pointer;		
		opacity:0;
		-moz-animation: closebutton 1s 2s forwards; 
		-webkit-animation: closebutton 1s 2s forwards; 
		-o-animation: closebutton 1s 2s forwards; 
		animation: closebutton 1s 2s forwards; 
	}

	@keyframes closebutton  {to{opacity:1;}}
	@-webkit-keyframes closebutton  {to{opacity:1;}}

	.start-screen-container {
		z-index: 42;
		border-radius: 10px;
		position: absolute;
		left: 0;
		width: 100%;
		height: 400px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.6));
		z-index:10000;
	}

	.pause-screen {
		z-index: 20;
		display: flex;
		justify-content: center;
		justify-items: center;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
	}

	.start-icon {
		width: 94px;
		height: 94px;
		border-radius: 50%;
		align-self: center;
		margin-top: 20px;
		transition: all 0.2s ease-in-out;
	}

	.pause-screen:hover > .start-icon {
		transform: scale(1.1);
	}

	.enter-transition {
		visibility: visible;
		opacity: 1;
		transform: scale(1);
		transition: all 250ms;
	}

</style>
